import { useRollbar } from '@rollbar/react';
import { UseQueryResult, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchSelector } from 'common/state/common';
import { KPIS } from 'common/types/kpi';
import { useCallback } from 'react';
import { useRecoilValue } from 'recoil';
import { LogArgument } from 'rollbar';
import { API_URLS } from 'settings/api';

const ALL_KPIS_QUERY_KEY = ['allKpis'];

export const useGetAllKpis = (): UseQueryResult<KPIS[], unknown> => {
  const { fetchGet } = useRecoilValue(fetchSelector);
  const rollbar = useRollbar();
  return useQuery(
    ALL_KPIS_QUERY_KEY,
    async () => {
      try {
        return await fetchGet<KPIS[]>(API_URLS.KPIS);
      } catch (e: unknown) {
        rollbar.info('useGetAllKpis error', e as LogArgument);
      }
    },
    {
      staleTime: Infinity,
    },
  );
};

export const useEnsureAllKpis = (): (() => Promise<KPIS[] | undefined>) => {
  const { fetchGet } = useRecoilValue(fetchSelector);
  const queryClient = useQueryClient();

  return useCallback(
    () =>
      queryClient.ensureQueryData({
        queryKey: ALL_KPIS_QUERY_KEY,
        queryFn: () => fetchGet<KPIS[]>(API_URLS.KPIS),
        staleTime: Infinity,
      }),
    [queryClient, fetchGet],
  );
};
